// extracted by mini-css-extract-plugin
module.exports = {"navLink":"xp","linkButtonFrame":"xq","linkButton":"xr","navLinkWhileSearching":"xs"};